import React from 'react';
import { Check as CheckIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { scopeLayers, costLines, costTotal } from '../../data/proposal';
export function ScopeSection() {
  return <Section id="scope" index="11" label="Proposed scope" data-id="element-247" data-mp="1k6jfs2xgtdfy">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-248" data-mp="1f7gachdkp57g">
        <SectionTitle data-id="element-249" data-mp="ri42bktzf36q">Proposed scope & investment.</SectionTitle>
        <Lead data-id="element-250" data-mp="rinkn2njntla">
          Build the master once, produce the series per case, then activate and support it market
          by market.
        </Lead>
      </div>

      <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-251" data-mp="11gtj1aa56hle">
        {scopeLayers.map(layer => <article key={layer.index} className="flex flex-col rounded-xl border border-white/10 bg-white/[0.03] p-5" data-id="element-252" data-mp="wgp3pnkyzswr">
            <div className="flex items-baseline justify-between gap-3" data-id="element-253" data-mp="27wm3k6ucjx8r">
              <p className="font-body text-[11px] tracking-[0.2em] text-primary" data-id="element-254" data-mp="27wdnk62xgbtc">{layer.index}</p>
              <p className="font-heading text-2xl text-primary" data-id="element-255" data-mp="sr82wygwtlf">{layer.price}</p>
            </div>
            <h3 className="mt-1.5 font-heading text-lg leading-tight text-white" data-id="element-256" data-mp="5q9d4c9d6oo5">{layer.title}</h3>
            <p className="mt-1 font-body text-xs text-white/45" data-id="element-257" data-mp="aryl1j1aim80">{layer.priceNote}</p>
            <ul className="mt-3 space-y-1.5 border-t border-white/10 pt-3" data-id="element-258" data-mp="fprssgi8roae">
              {layer.items.slice(0, 5).map(item => <li key={item} className="flex gap-2 font-body text-xs text-white/60" data-id="element-259" data-mp="3e62uetbis469">
                  <CheckIcon size={12} weight="bold" className="mt-0.5 shrink-0 text-primary" aria-hidden="true" data-id="element-260" data-mp="3j4w8amupxx6y" />
                  {item}
                </li>)}
            </ul>
          </article>)}
      </div>

      <div className="mt-6 overflow-hidden rounded-xl border border-white/12" data-id="element-261" data-mp="30g903vh8wrp5">
        <table className="w-full border-collapse text-left" data-id="element-262" data-mp="2sftbrq4nl16v">
          <caption className="sr-only" data-id="element-263" data-mp="2se8fnw2oxa6w">Indicative campaign costing</caption>
          <tbody data-id="element-264" data-mp="2nfotbuk6pwe0">
            {costLines.map(line => <tr key={line.label} className={`border-b border-white/10 ${line.optional ? 'bg-white/[0.015]' : ''}`} data-id="element-265" data-mp="325mmkowz1ca2">
                <th scope="row" className="px-5 py-3 font-normal" data-id="element-266" data-mp="2x71igeelm8gc">
                  <span className="flex flex-wrap items-center gap-2 font-heading text-base text-white" data-id="element-267" data-mp="29g5obamo715x">
                    {line.label}
                    {line.optional ? <span className="rounded-full border border-secondary/40 px-2 py-0.5 font-body text-[9px] uppercase tracking-[0.14em] text-secondary" data-id="element-268" data-mp="2jev2asbg41gw">
                        Optional
                      </span> : null}
                  </span>
                  <span className="mt-0.5 block max-w-2xl font-body text-xs leading-relaxed text-white/45" data-id="element-269" data-mp="3uw4npke4x3ku">
                    {line.detail}
                  </span>
                </th>
                <td className="hidden px-5 py-3 text-right align-middle font-body text-sm text-white/60 sm:table-cell" data-id="element-270" data-mp="180un74bvyn5">
                  {line.unit}
                </td>
                <td className="hidden px-5 py-3 text-right align-middle font-body text-sm text-white/60 md:table-cell" data-id="element-271" data-mp="3ofcx00e79yvh">
                  {line.quantity}
                </td>
                <td className="px-5 py-3 text-right align-middle font-heading text-lg text-white" data-id="element-272" data-mp="jzbi1eauhtaa">
                  {line.amount}
                </td>
              </tr>)}
          </tbody>
        </table>

        <div className="flex flex-wrap items-center justify-between gap-3 bg-primary/[0.08] px-5 py-4" data-id="element-273" data-mp="b6gld8zg15w4">
          <div data-id="element-274" data-mp="f7scxk1vo16y">
            <p className="font-heading text-lg text-white" data-id="element-275" data-mp="f7jw5h2mwbqh">{costTotal.label}</p>
            <p className="mt-0.5 max-w-2xl font-body text-xs leading-relaxed text-white/50" data-id="element-276" data-mp="12xmlvqj2t5lx">
              {costTotal.note}
            </p>
          </div>
          <p className="font-heading text-3xl text-primary" data-id="element-277" data-mp="3g6gwgjwdt1h6">{costTotal.amount}</p>
        </div>
      </div>

      <p className="mt-4 font-body text-xs text-white/45" data-id="element-278" data-mp="3b7ngmktmgydu">
        All figures in EUR, excluding VAT and media spend.
      </p>
    </Section>;
}